// import $ from 'jquery';

function DropDown(el) {
    this.dd = el;
    this.placeholder = this.dd.children('span');
    this.opts = this.dd.find('ul.dropdown > li');
    this.val = '';
    this.index = -1;
    console && console.warn('Untested.Code', el);
    this.initEvents();
}

DropDown.prototype = {
    initEvents : function() {
        var obj = this;

        obj.dd.on('click', function(event){
            $(this).toggleClass('active');
            return false;
        });

        obj.opts.on('click',function(){
            var opt = $(this);
            obj.val = opt.text();
            obj.index = opt.index();
            obj.placeholder.text(obj.val);
        });
    },
    getValue : function() {
        return this.val;
    },
    getIndex : function() {
        return this.index;
    }
};

$(function() {

    var dd = new DropDown( $('#dd') );

    $(document).click(function() {
        // all dropdowns
        $('.blog-filter').removeClass('active');
    });

    $(".dropdown li").on("click", function(e) {
        $(this)
            .addClass("filter-selected")
            .siblings()
            .removeClass("filter-selected");
    });

});


// WEBPACK FOOTER //
// ./client/src/site__fus078/components/custom-dropdown/index.js